// @ts-nocheck


import React, { Component } from 'react';
import { navigate } from '../../../lib/routerAdapter';

import { Tabs, TabItem } from '../../../components/ui';





export default class HeaderTabs extends Component {
  render() {
    return (
      <Tabs defaultTab={this.props.selectedTab}>
        <TabItem
          tabKey="general"
          label="Общие работы"
          onClick={() => navigate(`/admin/maintenance-operation-groups`)} />

        <TabItem
          tabKey="byModel"
          label="Работы по модели"
          onClick={() => navigate(`/admin/maintenance-operations-by-brand`)} />

      </Tabs>);

  }
}
